export const COLOR_MAP = [
    "#EF6C00", // Orange
    "#F9A825", // Yellow
    "#2E3B8B", // Deep blue
    "#00838F", // Cyan
    "#311B92", // Deep indigo variant
    "#D81B60", // Pink
    "#1976D2", // Blue
    "#388E3C", // Green
    "#7B1FA2", // Purple
    "#C62828", // Red
    "#AD1457", // Deep pink
    "#6A1B9A", // Deep purple
    "#4527A0", // Indigo
    "#283593", // Deep indigo
    "#1565C0", // Strong blue
    "#0277BD", // Light blue
    "#00695C", // Teal
    "#2E7D32", // Forest green
    "#558B2F", // Light green
    "#9E9D24", // Lime
    "#FF8F00", // Amber
    "#D84315", // Deep orange
    "#4E342E", // Brown
    "#37474F", // Blue grey
    "#B71C1C", // Deep red
    "#880E4F", // Deep pink variant
    "#4A148C", // Deep purple variant
    "#1A237E", // Darker blue
    "#0D47A1", // Strong blue variant
    "#006064", // Deep cyan
];
